import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.search";
/* eslint-disable */
import { hideLoading, toast as _toast, showLoading as _showLoading } from '@ykz/ykz-util/base';
import { isWX, isIos, addQiniuParams, previewImage } from '@ykz/ykz-util/platform';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'select_standard',
  data: function data() {
    return {
      isItemRule: {},
      rule: {},
      //规格限制
      loadSpecification: false,
      //加载规格弹框
      showSpecification: false,
      //显示规格弹框
      specificationSlideDown: true,
      //规格弹框是否滑下，默认true
      showDownloadTips: false,
      //app下载提示框

      payMoney: 0,
      //应付金额
      buyNum: 1,
      //购买数量
      maxBuyNum: 1,
      //最大购买数
      specDetail: {},
      //规格详情数据
      standardList: {},
      //存放objSpecData对象,规格id属性为键,加快索引
      priceAndStockNum: {},
      //specIdKey值当做键，加快索引速度
      selectedStandardObj: {},
      //选中的规格对象，存放着规格对象
      standardTxt: "",
      //规格文案
      standardHeight: 975 * (window.innerWidth / 750),
      //规格弹框高度，默认975
      finishSelected: false,
      //选择完规格的标志
      specIdKey: "",
      //选中项目规格对应的索引值（priceAndStockNum对象的键）
      promoter: {},
      //推广员信息
      monthList: [],
      //日历数据
      dayList: [],
      //某个月的日数据

      goodId: "",
      //商品id
      activityId: "",
      //活动id
      orderNo: getUrlParams('orderNo') || "",
      //订单号
      isShowTicket: false,
      //是否为演出票产品，默认false
      isMultipleDetails: false,
      //是否为多产品类型
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      isReviewing: false,
      //iOS审核判断,默认false
      isWxInstalled: window.mobileEnv == "app" ? false : true,
      //用户设备是否有安装微信
      isSpecialPage: location.href.search(/specialDetails/) != -1,
      //是否是特产详情页

      item: {},
      //需要处理的对象，更新父组件数据
      fn_call_back: function fn_call_back() {},
      //通过参数传递过来的点击按钮触发的方法,
      btnText: "",
      //底部栏按钮文案
      type: 1,
      //1、详情页   2、购物车页  非必传  ，默认1,
      count: 0,
      //用来标记相关接口是否都已经请求完成
      isNeedAddCart: false,
      //是否需要加入购物车，判断规格选择框按钮的功能
      isCalendarMode: false,
      //演出票是否需要展示日历模式，默认false
      seatingMap: "",
      //座位图地址
      useDate: [],
      //演出票日历数据
      selectDate: {},
      //用户所选择的日历时间
      activeGroupBuyIndex: 0 // 选中的拼团阶梯索引
    };
  },

  props: {
    // btnCallback: {
    //     type: Function,
    //     default: function () {}
    // },
    buyBtnTxt: {},
    specKey: {},
    cartCount: {},
    isOnline: {},
    standardText: {},
    isActivity: {},
    packageName: {},
    //多产品类型，所选择的套餐产品名称
    groupBuySteps: {
      // 拼团阶梯
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groupBuySku: {
      // 拼团的每个阶梯和sku的价格
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groupBuyJoin: Boolean,
    // 是否是参与拼团
    groupJoinLimit: Number // 拼团的人数, 当时参与拼团的时候不能选拼团人数，该人数手动传入
  },

  watch: {
    specIdKey: function specIdKey(val) {
      this.$emit("update:specKey", val);
    },
    standardTxt: function standardTxt(val) {
      this.$emit("update:standardText", val);
    }
  },
  filters: {
    //图片链接增加七牛图片处理参数
    filterImgLink: function filterImgLink(value, isOneToOneRatio) {
      return addQiniuParams(value, isOneToOneRatio ? "?imageView2/1/w/200/h/200/interlace/1/q/85/" : "?imageView2/1/w/240/h/160/interlace/1/q/85/", isOneToOneRatio ? "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_172_172.png" : "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_240_160.png");
    }
  },
  mounted: function mounted() {
    // debugger
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    console.log("ycf组件初始化：select_standard");
    window.componentCenter.selectStandard = this;

    //iOS审核判断，审核版本和上线版本展示样式不同
    if (this.isAPP) {
      var that = this;
      ykzApp.ready(function () {
        that.isReviewing = ykzApp.isIOSReviewing(); //iOS审核判断，审核版本和上线版本展示样式不同
        ykzApp.getGlobalSettings({
          success: function success(settings) {
            that.isWxInstalled = settings.wxInstalled; //判断用户设备是否有安装微信
          }
        });
      });
    }
  },

  computed: {
    //返回原价
    getRetailPrice: function getRetailPrice() {
      if (this.isShowTicket) {
        //演出票不显示原价
        return "";
      }
      if (this.specIdKey) {
        if (this.priceAndStockNum[this.specIdKey].skuPrice) {
          return Math.round(this.priceAndStockNum[this.specIdKey].skuPrice * this.buyNum * 100) / 100;
        } else {
          return "";
        }
      } else {
        if (this.specDetail.retailPrice) {
          return Math.round(this.specDetail.retailPrice * this.buyNum * 100) / 100;
        } else {
          return "";
        }
      }
    },
    //返回单价
    getPayMoney: function getPayMoney() {
      var payMoney = 0;
      var skuId;
      var groupBuyDiscount = 0;
      if (!this.specIdKey) {
        payMoney = this.specDetail.minPrice || 0;
      } else if (this.priceAndStockNum[this.specIdKey]) {
        skuId = this.priceAndStockNum[this.specIdKey].skuId;
        if (this.type == 1) {
          payMoney = this.activityId ? this.priceAndStockNum[this.specIdKey].activityPrice : this.priceAndStockNum[this.specIdKey].price;
        } else {
          payMoney = this.priceAndStockNum[this.specIdKey].price;
        }
      }
      if (skuId) {
        var memberLimit = this.groupBuyJoin ? this.groupJoinLimit : this.groupBuySteps[this.activeGroupBuyIndex] ? this.groupBuySteps[this.activeGroupBuyIndex].memberLimit : 0;
        var groupStep = this.groupBuySku.find(function (item) {
          return Number(item.skuId) === Number(skuId) && item.memberLimit === memberLimit;
        });
        groupBuyDiscount = groupStep ? groupStep.discountAmount : 0;
      }
      this.payMoney = Math.max(payMoney - groupBuyDiscount, 0);
      return Math.round(this.payMoney * 100) / 100;
    },
    //返回总价
    getTotalPayMoney: function getTotalPayMoney() {
      return this.payMoney >= 0 ? Math.round(Math.max(this.payMoney * this.buyNum, 0) * 100) / 100 : "—";
    },
    // 拼团优惠价
    groupBuyDiscount: function groupBuyDiscount() {
      var skuId;
      if (this.specIdKey) {
        skuId = this.priceAndStockNum[this.specIdKey].skuId;
      }
      if (skuId) {
        var memberLimit = this.groupBuyJoin ? this.groupJoinLimit : this.groupBuySteps[this.activeGroupBuyIndex] ? this.groupBuySteps[this.activeGroupBuyIndex].memberLimit : 0;
        var groupStep = this.groupBuySku.find(function (item) {
          return Number(item.skuId) === Number(skuId) && item.memberLimit === memberLimit;
        });
        return groupStep ? groupStep.discountAmount : 0;
      }
      return 0;
    }
  },
  methods: {
    /**
     *[getSpecification 购物车页调用传入的参数，显示选择规格弹框]
     * @param  {[type]} options [description]
     * options: {
     *     goodId: "15324",// 必传 产品id
     *     item:{},    //需要处理的对象，更新父组件数据,非必传
     *     fn_call_back: function(item){}, //非必传，底部按钮触发的方法,默认隐藏规格弹框
     *     btnText: '', // 底部按钮名称，非必传，默认‘确认’
     *     type:1  //1、详情页   2、购物车页  非必传  ，默认1
     * }
     * @return {[type]}         [description]
     */
    getSpecification: function getSpecification(options) {
      var that = this;
      options = options || {};
      this.type = options.type || 1;
      this.goodId = options.goodId || "";
      this.activityId = options.activityId || "";
      this.item = options.item || {};
      this.fn_call_back = options.fn_call_back || function () {
        that.slideDownSpecification();
      };
      this.btnText = options.btnText || "确认";
      if (this.type == 1) {
        this.specDetail = options.specDetail || {};
        this.rule = options.specDetail && options.specDetail.restrictionDetails;
        this.standardList = options.standardList || {};
        this.priceAndStockNum = options.priceAndStockNum || {};
        this.promoter = options.promoter || {};
        this.isMultipleDetails = options.isMultipleDetails || false; //多产品模式
        //演出票模式
        if (options.isShowTicket) {
          this.isShowTicket = options.isShowTicket;
          this.calendarList = options.calendarList || []; //选择日期时间后，需要索引的列表
          this.useDate = options.useDate || []; //日历数据
          this.seatingMap = options.seatingMap || "";
          this.buyNum = options.specDetail.minNum || 1;
          if (this.useDate.length > 6) {
            //日历数据大于6时，规格框展示日历模式
            this.isCalendarMode = true;
            this.standardHeight = window.innerHeight;
            this.calendar(this.useDate);
          } else {
            this.isCalendarMode = false;
          }
        } else {
          if (Object.getOwnPropertyNames(this.standardList).length == 1 || Object.getOwnPropertyNames(this.priceAndStockNum).length == 1) {
            this.finishSelected = true;
            return;
          }
        }
        this.loadSpecification = true;
        this.setStandardTxt(1);
        !this.orderNo && this.$nextTick(function () {
          this.setMaxBuyNum(this.specDetail.specMaxNum);
          if (this.isShowTicket) {
            if (this.isCalendarMode) {
              outerloop: for (var i in this.monthList) {
                this.selectMonth(this.monthList[i]);
                for (var j in this.monthList[i].dayList) {
                  if (this.monthList[i].dayList[j].isBook == 1 && this.monthList[i].dayList[j].stockNum >= this.buyNum) {
                    this.selectDay(this.monthList[i].dayList[j]);
                    break outerloop;
                  }
                }
              }
            } else {
              for (var k in this.useDate) {
                if (this.useDate[k].isBook == 1 && this.useDate[k].stockNum >= this.buyNum) {
                  this.selectDay(this.useDate[k]);
                  break;
                }
              }
            }
          } else {
            this.autoSelectedStandard();
          }
        });
        return; //详情页调用该组件，不需要再调用获取规格和奖励数据的接口
      } else {
        this.loadSpecification = true;
      }
      databus({
        type: "post",
        url: "/apiv2/room/getSpec",
        data: {
          goodId: that.goodId,
          userId: window.userId
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            res.content.baseValueUnit = "份";
            that.specDetail = res.content;
            that.specDetail.canBuy = that.specDetail.maxNum; //canBuy字段暂时屏蔽
            that.setMaxBuyNum(that.specDetail.specMaxNum);
            that.priceAndStockNum = res.content.priceAndStockNum;
            var standardList = {};
            for (var i in res.content.objSpecData) {
              standardList[res.content.objSpecData[i].projectName] = {
                typeName: res.content.objSpecData[i].projectName,
                checked: false,
                //对每类规格添加选中属性,默认没有
                standard: {}
              };
              for (var j in res.content.objSpecData[i].specData) {
                standardList[res.content.objSpecData[i].projectName].standard[j] = {
                  id: +j,
                  name: res.content.objSpecData[i].specData[j].name,
                  selected: false,
                  //对每个规格添加已选择属性,默认值false
                  disabled: false //对每个规格添加不可选属性,默认值false
                };
              }
            }

            that.standardList = standardList;
            that.setStandardTxt(1);
            if (typeof that.item.quantity != "undefined") {
              that.buyNum = that.item.quantity == 0 ? 1 : +that.item.quantity;
            }
            if (typeof that.item.specIdKey != "undefined") {
              that.specIdKey = that.item.specIdKey;
            }
          }
        },
        error: function error() {
          that.toast("网络异常");
        },
        beforeSend: function beforeSend() {
          that.showLoading();
          that.count = 0;
          that.getPromoter();
        },
        complete: function complete() {
          that.count++;
          if (that.count == 2) {
            that.$nextTick(function () {
              that.autoSelectedStandard();
              hideLoading();
              that.slideUpSpecification();
            });
          }
        }
      });
    },
    btnCallback: function btnCallback() {
      this.$emit('buybtn');
    },
    //更新奖励数据
    updatePromoterData: function updatePromoterData(promoter) {
      this.promoter = promoter;
      this.querySpecIdKey();
      this.setScrollHeight();
    },
    //获取推广员是否可推广该产品，获取相应奖励
    getPromoter: function getPromoter() {
      var that = this;
      databus({
        url: "/apiv2/marketing/getShareStautsOfPromoter",
        type: "get",
        data: {
          productId: this.goodId,
          fxbInviteCode: getUrlParams("fxbInviteCode") || ''
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            if (that.isAPP && window.isTourist) {
              res.content.isShare = 0;
              res.content.isPromoter = 0;
            } else {
              res.content.tempSellComm = "";
              res.content.tempAppSellComm = "";
            }
            that.promoter = res.content;
          } else {
            console.log(res.message);
          }
        },
        error: function error() {
          that.toast("网络有误，请重试");
        },
        beforeSend: function beforeSend() {
          that.promoter = {};
        },
        complete: function complete() {
          that.count++;
          if (that.count == 2) {
            that.autoSelectedStandard();
            that.$nextTick(function () {
              hideLoading();
              that.slideUpSpecification();
            });
          }
        }
      });
    },
    //初始化规格数据
    initStandardInfo: function initStandardInfo() {
      var that = this,
        skuList = {};
      this.calendarList.map(function (item) {
        if (item.sellDate == that.selectDate.sellDate) {
          skuList[item.skuId] = {
            price: item.price,
            stockNum: item.stockNum
          };
        }
      });
      for (var specIdKey in this.priceAndStockNum) {
        var sku = skuList[this.priceAndStockNum[specIdKey].skuId];
        if (sku) {
          this.priceAndStockNum[specIdKey].price = sku.price;
          this.priceAndStockNum[specIdKey].activityPrice = sku.price;
          this.priceAndStockNum[specIdKey].stockNum = sku.stockNum;
        } else {
          this.priceAndStockNum[specIdKey].stockNum = 0; //没有索引值，即该规格关闭状态，用库存为0代替，表示不可选
        }
      }

      for (var typeName in this.standardList) {
        this.standardList[typeName].checked = false;
        for (var id in this.standardList[typeName].standard) {
          this.standardList[typeName].standard[id].selected = false;
          this.standardList[typeName].standard[id].disabled = false;
        }
      }
      this.selectedStandardObj = {};
      this.finishSelected = false;
      this.specIdKey = "";
      if (this.promoter.skuCommList) {
        this.promoter.tempSellComm = "";
        this.promoter.tempAppSellComm = "";
      }
      this.setMaxBuyNum(this.selectDate.stockNum);
      this.autoSelectedStandard();

      //演出票产品，默认选择第一个可选的“场次”类型规格
      if (this.standardList["场次"] && !this.standardList["场次"].checked) {
        for (var id2 in this.standardList["场次"].standard) {
          if (!this.standardList["场次"].standard[id2].disabled) {
            this.selectedSpecification(this.standardList["场次"], this.standardList["场次"].standard, this.standardList["场次"].typeName, this.standardList["场次"].standard[id2]);
            break;
          }
        }
      }
      this.setStandardTxt(this.selectDate.sellDate ? 2 : 1);
      this.setScrollHeight();
    },
    //数据加工、默认选择规格
    autoSelectedStandard: function autoSelectedStandard() {
      var that = this;
      that.finishSelected = false;
      that.selectedStandardObj = {};
      if (that.type == 1) {
        if (that.maxBuyNum && Object.getOwnPropertyNames(that.priceAndStockNum).length == 2) {
          for (var typeName in that.standardList) {
            for (var id in that.standardList[typeName].standard) {
              that.selectedSpecification(that.standardList[typeName], that.standardList[typeName].standard, typeName, that.standardList[typeName].standard[id]);
            }
          }
        } else {
          if (Object.getOwnPropertyNames(that.standardList).length == 2) {
            that.querySpecIdKey();
            if (that.isMultipleDetails) {
              var minPrice = -1,
                //有库存的最低价
                tempSpecIdKey = "",
                //最低价所对应的specIdKey
                value = {}; //存放priceAndStockNum[specIdKey]
              for (var specIdKey in that.priceAndStockNum) {
                value = that.priceAndStockNum[specIdKey];
                if (value.stockNum && value.stockNum >= value.minNum) {
                  if (minPrice == -1) {
                    minPrice = value.price;
                    tempSpecIdKey = specIdKey;
                  }
                  if (minPrice > value.price) {
                    minPrice = value.price;
                    tempSpecIdKey = specIdKey;
                  }
                }
              }
              for (var typeName2 in that.standardList) {
                if (that.standardList[typeName2].standard[tempSpecIdKey]) {
                  that.selectedSpecification(that.standardList[typeName2], that.standardList[typeName2].standard, typeName2, that.standardList[typeName2].standard[tempSpecIdKey]);
                  that.buyNum = that.priceAndStockNum[tempSpecIdKey].minNum || 1;
                  break;
                }
              }
            }
          }
        }
      } else if (that.type == 2) {
        if (that.maxBuyNum && that.priceAndStockNum[that.specIdKey] && that.buyNum <= that.priceAndStockNum[that.specIdKey].stockNum) {
          for (var typeName3 in that.standardList) {
            for (var id2 in that.standardList[typeName3].standard) {
              if (that.specIdKey.match(id2)) {
                that.selectedSpecification(that.standardList[typeName3], that.standardList[typeName3].standard, typeName3, that.standardList[typeName3].standard[id2]);
                break;
              }
            }
          }
        } else {
          that.specIdKey = "";
          Object.getOwnPropertyNames(that.standardList).length == 2 && that.querySpecIdKey();
        }
      }
    },
    //toast
    toast: function toast(str) {
      _toast(str);
    },
    //Loading
    showLoading: function showLoading() {
      _showLoading({
        cover: true,
        opacity: 0
      });
    },
    //改变购买数量
    changeBuyNum: function changeBuyNum(str) {
      if (this.orderNo) return;
      if (str == 'less') {
        if (this.isShowTicket || this.isMultipleDetails) {
          if (this.buyNum <= this.specDetail.minNum) {
            this.toast("该商品最少需预订" + this.specDetail.minNum + this.specDetail.baseValueUnit + "！");
            return false;
          }
        } else {
          if (this.buyNum <= 1) {
            this.toast("该商品最少需预订1" + this.specDetail.baseValueUnit + "！");
            return false;
          }
        }
        this.buyNum--;
        this.querySpecIdKey();
      } else {
        if (this.specDetail.restrictionDetails) {
          /*if((this.isShowTicket || this.isMultipleDetails) && this.specDetail.minNum > this.specDetail.canBuy && this.specDetail.canBuy != -1) {
          	this.toast("商品" + this.specDetail.minNum + this.specDetail.baseValueUnit + "起购，您已下单" + (this.specDetail.maxNum - this.specDetail.canBuy) + this.specDetail.baseValueUnit + "，超出购买限制，请关注公众号并于订单中心查看订单");
          	return false;
          }*/
          if (this.specDetail.restrictionDetails.weChat && this.buyNum >= this.specDetail.restrictionDetails.limitMaxNum && this.specDetail.isSkuLimit) {
            var weChatDay = this.specDetail.restrictionDetails.weChat.day;
            this.toast("每个微信号" + (weChatDay ? weChatDay + "天内限购" : "限购") + this.specDetail.restrictionDetails.limitMaxNum + this.specDetail.baseValueUnit + "！");
            return false;
          }
          if (this.specDetail.restrictionDetails.weChat && this.specDetail.canBuy != -1 && this.buyNum >= this.specDetail.canBuy && !Number(this.specDetail.isSkuLimit)) {
            var weChatDay = this.specDetail.restrictionDetails.weChat.day;
            if (this.specDetail.canBuy == this.specDetail.maxNum) {
              this.toast("每个微信号" + (weChatDay ? weChatDay + "天内限购" : "限购") + this.specDetail.maxNum + this.specDetail.baseValueUnit + "！");
            } else {
              this.toast("每个微信号" + (weChatDay ? weChatDay + "天内限购" : "限购") + this.specDetail.maxNum + this.specDetail.baseValueUnit + "，您已下单" + (this.specDetail.maxNum - this.specDetail.canBuy) + this.specDetail.baseValueUnit + "，请关注公众号并于订单中心查看订单");
            }
            return false;
          }
          if (this.specDetail.restrictionDetails.phone && this.buyNum >= this.specDetail.restrictionDetails.phone.limit) {
            this.toast("每个联系人手机号" + (this.specDetail.restrictionDetails.phone.day ? this.specDetail.restrictionDetails.phone.day + "天内限购" : "限购") + this.specDetail.restrictionDetails.phone.limit + this.specDetail.baseValueUnit);
            return false;
          }
          if (this.specDetail.restrictionDetails.idCard && this.buyNum >= this.specDetail.restrictionDetails.idCard.limit) {
            this.toast("每个证件号码" + (this.specDetail.restrictionDetails.idCard.day ? this.specDetail.restrictionDetails.idCard.day + "天内限购" : "限购") + this.specDetail.restrictionDetails.idCard.limit + this.specDetail.baseValueUnit);
            return false;
          }
        }
        if ((this.isShowTicket || this.isMultipleDetails) && this.specDetail.maximum != -1 && this.buyNum >= this.specDetail.maximum) {
          this.toast("该商品最多可购买" + this.specDetail.maximum + this.specDetail.baseValueUnit + "！");
          return false;
        }
        if (this.buyNum >= this.maxBuyNum) {
          this.toast("购买数量不能超出库存");
          return false;
        }
        this.buyNum++;
        this.querySpecIdKey();
      }
    },
    //向上滑动显示规格弹框
    slideUpSpecification: function slideUpSpecification(isNeedAddCart) {
      var that = this;
      that.showSpecification = true;
      that.setScrollHeight();
      setTimeout(function () {
        that.specificationSlideDown = false;
        that.isNeedAddCart = isNeedAddCart ? true : false;
        location.hash != "#standard" && (location.hash = "standard");
        if (that.isCalendarMode && !document.referrer && isWX() && isIos()) {
          setTimeout(function () {
            that.standardHeight = window.innerHeight; //ios在微信内置浏览器上，会有底部导航栏，会改变页面高度，需重新赋值
            that.setScrollHeight();
          }, 50);
        }
      }, 30);
    },
    //向下滑动隐藏规格弹框
    slideDownSpecification: function slideDownSpecification(callback) {
      var that = this;
      that.specificationSlideDown = true;
      setTimeout(function () {
        that.showSpecification = false;
        location.hash == "#standard" && history.go(-1);
        if (typeof callback == "function") {
          callback();
        }
      }, 300);
    },
    //购物车页调用，点击底部按钮,执行传过来的函数方法
    clickBottomBtn: function clickBottomBtn() {
      if (!this.specDetail.specMaxNum || this.specDetail.statusIs != "1") {
        return false;
      }
      if (this.finishSelected) {
        if (typeof this.item.skuId != "undefined") {
          this.item.skuId = this.priceAndStockNum[this.specIdKey].skuId;
        }
        if (typeof this.item.stockNum != "undefined") {
          this.item.stockNum = this.priceAndStockNum[this.specIdKey].stockNum;
        }
        if (typeof this.item.price != "undefined") {
          this.item.price = this.priceAndStockNum[this.specIdKey].price;
        }
        if (typeof this.item.specIdKey != "undefined") {
          this.item.specIdKey = this.specIdKey;
        }
        if (typeof this.item.limit != "undefined") {
          this.item.limit = this.specDetail.maxNum;
        }
        if (typeof this.item.quantity != "undefined") {
          this.item.quantity = this.buyNum;
        }
        if (typeof this.item.status != "undefined") {
          this.item.status = this.maxBuyNum ? 1 : 0;
        }
        if (typeof this.item.status != "undefined" && typeof this.item.skuName != "undefined") {
          var that = this;
          this.item.skuName = function () {
            var arr = [];
            for (var i in that.selectedStandardObj) {
              arr.push(that.selectedStandardObj[i].name);
            }
            return arr.join("，");
          }();
        }
        this.fn_call_back(this.item);
      } else {
        this.toast(this.maxBuyNum ? "请选中规格！" : "该产品已被抢光了");
      }
    },
    //选择规格
    selectedSpecification: function selectedSpecification(project, standard, typeName, specification) {
      console.log('选择规格', project, standard, typeName, specification);
      var limitDetails = this.specDetail.limitDetails || [];
      var itemRule = {};
      if (this.orderNo || specification.disabled) return;
      if (this.isShowTicket && !this.selectDate.sellDate) {
        this.toast("请先选择时间");
        return false;
      }
      if (specification.selected) {
        if (this.isMultipleDetails) return; //多产品类型不允许取消选中状态
        //该规格已被选中，取消选中
        specification.selected = false;
        project.checked = false;
        delete this.selectedStandardObj[typeName];
        this.cancelSelected();
        this.specDetail.restrictionDetails = this.rule;
      } else {
        //该规格未被选中，选中改规格
        for (var id in standard) {
          if (standard[id].selected) {
            standard[id].selected = false;
            break;
          }
        }
        project.checked = true;
        specification.selected = true;
        limitDetails.filter(function (item) {
          if (item.specIdKey == specification.id) {
            itemRule = item;
            return;
          }
        });
        this.isItemRule = JSON.stringify(itemRule);
        this.specDetail.restrictionDetails = this.isItemRule !== '{}' ? itemRule : this.rule;
        this.selectedStandardObj[typeName] = specification;
        this.setStandardTxt(2);
        this.querySpecIdKey();
      }
      this.setScrollHeight();
    },
    //取消选中的规格,判断一下是否需要重新设置disabled和specIdKey的值
    cancelSelected: function cancelSelected() {
      this.finishSelected = false;
      this.specIdKey = "";
      this.setMaxBuyNum(this.isShowTicket ? this.selectDate.stockNum : this.specDetail.specMaxNum);
      this.setStandardTxt(Object.getOwnPropertyNames(this.selectedStandardObj).length <= 1 ? 1 : 2);
      if (this.promoter.skuCommList) {
        this.promoter.tempSellComm = "";
        this.promoter.tempAppSellComm = "";
      }
      if (Object.getOwnPropertyNames(this.standardList).length > Object.getOwnPropertyNames(this.selectedStandardObj).length + 1) {
        for (var typeName in this.standardList) {
          for (var id in this.standardList[typeName].standard) {
            this.standardList[typeName].standard[id].disabled = false;
          }
        }
      }
      if (Object.getOwnPropertyNames(this.standardList).length == Object.getOwnPropertyNames(this.selectedStandardObj).length + 1) {
        for (var typeName2 in this.standardList) {
          if (this.standardList[typeName2].checked) {
            for (var id2 in this.standardList[typeName2].standard) {
              this.standardList[typeName2].standard[id2].disabled && (this.standardList[typeName2].standard[id2].disabled = false);
            }
          }
        }
      }
    },
    //查找specIdKey
    querySpecIdKey: function querySpecIdKey() {
      var that = this;
      if (!this.finishSelected) {
        //规格未选完，只剩一个的情况
        if (Object.getOwnPropertyNames(this.standardList).length == Object.getOwnPropertyNames(this.selectedStandardObj).length + 1) {
          for (var typeName in this.standardList) {
            if (!this.standardList[typeName].checked) {
              for (var id in this.standardList[typeName].standard) {
                setDisabled(this.selectedStandardObj, typeName, id);
              }
              break;
            }
          }
        }

        //规格选完了
        if (Object.getOwnPropertyNames(this.standardList).length == Object.getOwnPropertyNames(this.selectedStandardObj).length) {
          this.finishSelected = true;
        }
      }
      if (this.finishSelected) {
        this.specIdKey = getIdArrStr(this.selectedStandardObj);

        //多产品类型选择完成后，specDetail数据的初始化
        if (this.isMultipleDetails) {
          this.$emit("update:packageName", this.priceAndStockNum[this.specIdKey].goodsName);
          this.specDetail.coverPic = this.priceAndStockNum[this.specIdKey].coverPic;
          this.specDetail.minNum = this.priceAndStockNum[this.specIdKey].minNum || 1;
          this.specDetail.maximum = this.priceAndStockNum[this.specIdKey].maxNum;
          this.specDetail.restrictionDetails = this.priceAndStockNum[this.specIdKey].restrictionDetails;
          if (this.specDetail.restrictionDetails && this.specDetail.restrictionDetails.weChat) {
            this.specDetail.maxNum = this.specDetail.restrictionDetails.weChat.limit;
            this.specDetail.canBuy = this.specDetail.maxNum;
          }
        }
        this.setMaxBuyNum(this.priceAndStockNum[this.specIdKey].stockNum);

        //多产品类型选择完成后，购买数量特殊处理
        if (this.isMultipleDetails) {
          if (this.buyNum < this.specDetail.minNum || this.buyNum > this.maxBuyNum) {
            this.buyNum = this.specDetail.minNum;
          }
        }
        if (this.promoter.skuCommList) {
          var skuId = this.priceAndStockNum[this.specIdKey].skuId;
          this.promoter.tempSellComm = "";
          this.promoter.tempAppSellComm = "";
          for (var i in this.promoter.skuCommList) {
            if (skuId == this.promoter.skuCommList[i].skuId) {
              this.promoter.tempSellComm = this.promoter.skuCommList[i][this.promoter.isExcellence ? "sellComm" : "originalSellComm"];
              this.promoter.tempAppSellComm = this.promoter.skuCommList[i][this.promoter.isExcellence ? "appSellComm" : "originalAppSellComm"];
            }
          }
        }
        var obj = {}; //临时对象存放this.selectedStandardObj
        for (var typeName2 in this.selectedStandardObj) {
          obj = deepCopy(this.selectedStandardObj);
          delete obj[typeName2];
          for (var id2 in this.standardList[typeName2].standard) {
            if (this.standardList[typeName2].standard[id2].selected) {
              continue;
            }
            setDisabled(obj, typeName2, id2);
          }
        }
      }

      //设置disabled的值，selectedStandardObj：差一个规格选择完的selectedStandardObj，typeName：要设置的那一类规格的名称，id：规格的id
      function setDisabled(selectedStandardObj, typeName, id) {
        var value = that.priceAndStockNum[getIdArrStr(selectedStandardObj, id)];
        if (!value || !that.isMultipleDetails && value.stockNum < that.buyNum) {
          that.standardList[typeName].standard[id].disabled = true;
          return;
        }
        that.standardList[typeName].standard[id].disabled = false;

        //多产品类型不可选择规格规则(特殊：不可选择规格规则不跟购买数量比较)
        if (that.isMultipleDetails) {
          if (value.stockNum < value.minNum) {
            that.standardList[typeName].standard[id].disabled = true;
            return;
          }
          if (value.maxNum != -1 && value.maxNum < value.minNum) {
            that.standardList[typeName].standard[id].disabled = true;
            return;
          }
          if (value.restrictionDetails) {
            if (value.restrictionDetails.weChat && value.restrictionDetails.weChat.limit < value.minNum) {
              that.standardList[typeName].standard[id].disabled = true;
              return;
            }
            if (value.restrictionDetails.phone && value.restrictionDetails.phone.limit < value.minNum) {
              that.standardList[typeName].standard[id].disabled = true;
              return;
            }
            if (value.restrictionDetails.idCard && value.restrictionDetails.idCard.limit < value.minNum) {
              that.standardList[typeName].standard[id].disabled = true;
              return;
            }
          }
        }
      }

      //获取id从小到大排序连接起来的字符串,即specIdKey
      function getIdArrStr(selectedStandardObj, id) {
        var idArr = [];
        (id || id === 0) && idArr.push(id);
        for (var type_name in selectedStandardObj) {
          idArr.push(selectedStandardObj[type_name].id);
        }
        return idArr.sort(function (a, b) {
          return a - b;
        }).join("_");
      }

      //深拷贝，copied被拷贝的对象或数组，copy拷贝的对象
      function deepCopy(copied, copy) {
        copy = copy || {};
        for (var i in copied) {
          if (_typeof(copied[i]) === 'object') {
            copy[i] = copied[i].constructor === Array ? [] : {};
            deepCopy(copied[i], copy[i]);
          } else {
            copy[i] = copied[i];
          }
        }
        return copy;
      }
    },
    //设置用户能购买的最大数量
    setMaxBuyNum: function setMaxBuyNum(stockNum) {
      this.maxBuyNum = stockNum;
      if (this.specDetail.restrictionDetails) {
        if (this.specDetail.restrictionDetails.weChat && this.specDetail.canBuy != -1 && this.specDetail.canBuy < this.maxBuyNum) {
          this.maxBuyNum = this.specDetail.canBuy;
        }
        if (this.specDetail.restrictionDetails.phone && this.specDetail.restrictionDetails.phone.limit < this.maxBuyNum) {
          this.maxBuyNum = this.specDetail.restrictionDetails.phone.limit;
        }
        if (this.specDetail.restrictionDetails.idCard && this.specDetail.restrictionDetails.idCard.limit < this.maxBuyNum) {
          this.maxBuyNum = this.specDetail.restrictionDetails.idCard.limit;
        }
      }
      if ((this.isShowTicket || this.isMultipleDetails) && this.specDetail.maximum != -1 && this.maxBuyNum > this.specDetail.maximum) {
        this.maxBuyNum = this.specDetail.maximum;
      }
    },
    //判断奖励字段是否需要显示
    getIsShow: function getIsShow(value) {
      if (!value || typeof value != "string") {
        return false;
      }
      var numStr = value.replace(/[^0-9]+/g, '');
      if (numStr && numStr != 0) {
        return true;
      } else {
        return false;
      }
    },
    //设置规格文案,type(1.未选中的规格文案,2.选中的规格文案)
    setStandardTxt: function setStandardTxt(type) {
      var that = this;
      this.selectDate.sellDate && (type = 2);
      if (type == 1) {
        that.standardTxt = "请选择 " + function () {
          var arr = [];
          that.isShowTicket && arr.push("时间");
          for (var typeName in that.standardList) {
            arr.push(typeName);
          }
          return arr.join(" ");
        }();
      } else {
        that.standardTxt = "已选：" + function () {
          var arr = [];
          typeof that.selectDate.sellDate == "string" && arr.push('“' + that.selectDate.sellDate.replace(/-/g, ".") + that.selectDate.dateStr + '”');
          for (var typeName in that.selectedStandardObj) {
            arr.push('“' + that.selectedStandardObj[typeName].name + '”');
          }
          return arr.join(" ");
        }();
      }
    },
    //添加商品到购物车
    addToShoppingCart: function addToShoppingCart() {
      if (!this.finishSelected) {
        this.toast("请选中规格");
        return false;
      }
      if (this.addToCartLock) {
        return false;
      }
      this.addToCartLock = true;
      var that = this;
      databus({
        url: "/apiv2/cart/add",
        type: "post",
        data: {
          skuId: this.priceAndStockNum[this.specIdKey].skuId,
          qty: this.buyNum
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.$emit("update:cartCount", res.content.count || 1);
            that.slideDownSpecification(function () {
              that.toast("商品加入购物车成功");
            });
          } else {
            that.toast(res.message || "商品加入购物车失败，请重试！");
          }
        },
        error: function error() {
          that.toast("网络有误，请重试");
        },
        beforeSend: function beforeSend() {
          that.showLoading();
        },
        complete: function complete() {
          hideLoading();
          that.addToCartLock = false;
        }
      });
    },
    //获取空白格的数量
    getBlankSpaceNum: function getBlankSpaceNum(str) {
      var date = new Date(str);
      return date.getDay();
    },
    //生成日历 useDate(接口返回来的日历对象列表)
    calendar: function calendar(useDate) {
      var that = this,
        startObj = getDateObj(useDate[0].sellDate),
        endObj = getDateObj(useDate[useDate.length - 1].sellDate),
        index = 0,
        start = startObj.year * 12 + startObj.month,
        end = endObj.year * 12 + endObj.month,
        year = startObj.year,
        month = startObj.month;
      while (start <= end) {
        beCalendar(year, month);
        month++;
        if (month > 12) {
          month = 1;
          year++;
        }
        start++;
      }
      this.selectMonth(this.monthList[0]);

      //生成一个月的日历
      function beCalendar(year, month) {
        var dayList = [];
        for (var i = 1; i <= new Date(year, month, 0).getDate(); i++) {
          var sellDate = formatDate(year, month, i, "-");
          if (index < useDate.length && sellDate == useDate[index].sellDate) {
            dayList.push(useDate[index]);
            index++;
          } else {
            dayList.push({
              sellDate: sellDate,
              price: 0,
              stockNum: -1,
              dateStr: function () {
                switch (new Date(sellDate).getDay()) {
                  case 0:
                    return "周日";
                  case 1:
                    return "周一";
                  case 2:
                    return "周二";
                  case 3:
                    return "周三";
                  case 4:
                    return "周四";
                  case 5:
                    return "周五";
                  case 6:
                    return "周六";
                }
              }(),
              isBook: -1
            });
          }
        }
        that.monthList.push({
          dayList: dayList,
          month: month,
          selected: false
        });
      }

      //获取日期对象
      function getDateObj(str) {
        var date = {};
        if (str) {
          date = new Date(str);
        } else {
          date = new Date();
        }
        return {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate()
        };
      }

      //格式化日期
      function formatDate(year, month, day, str) {
        var y = year;
        var m = month;
        if (m < 10) m = "0" + m;
        var d = day;
        if (d < 10) d = "0" + d;
        return y + str + m + str + d;
      }
    },
    //选择月份
    selectMonth: function selectMonth(month) {
      if (this.dayList != month.dayList) {
        this.dayList = month.dayList;
        for (var i in this.monthList) {
          if (this.monthList[i].selected) {
            this.monthList[i].selected = false;
            break;
          }
        }
        month.selected = true;
      }
    },
    //选择日历
    selectDay: function selectDay(day) {
      if (day.isBook != 1 || day.stockNum == 0 || this.orderNo) {
        return false;
      } else {
        if (day.stockNum < this.buyNum) {
          this.toast("该商品最少需预订" + this.specDetail.minNum + this.specDetail.baseValueUnit + "，库存不足！");
          return false;
        }
        if (this.selectDate === day) {
          this.selectDate = {};
        } else {
          this.selectDate = day;
        }
        this.initStandardInfo(); //初始化规格数据
      }
    },

    //设置滚动区域的最大高度
    setScrollHeight: function setScrollHeight() {
      this.$nextTick(function () {
        if (!this.isReviewing && this.specIdKey && this.promoter.isShare && this.getIsShow(this.promoter.tempSellComm + this.promoter.tempAppSellComm)) {
          var commHeight = $(".specification-commission .commission-content").height();
          $(".specification-commission").css("height", commHeight);
          $(".specification-main").css("height", this.standardHeight - $(".specification-top").innerHeight() - commHeight);
        } else {
          $(".specification-commission").css("height", 0);
          $(".specification-main").css("height", this.standardHeight - $(".specification-top").innerHeight() - 0);
        }
      });
    },
    //打开座位图
    openSeatingMap: function openSeatingMap() {
      var that = this;
      if (that.isAPP) {
        if (!ykzApp.showPhotoGallery) {
          that.showDownloadTips = true;
        } else {
          ykzApp.showPhotoGallery({
            photoUrls: [that.seatingMap],
            curIndex: 0
          });
        }
      } else {
        previewImage({
          current: that.seatingMap,
          // 当前显示图片的http链接
          urls: [that.seatingMap] // 需要预览的图片http链接列表
        });
      }
    },
    selectGroupBuy: function selectGroupBuy(index) {
      console.log('选择套餐', index);
      this.activeGroupBuyIndex = index;
    }
  }
};